(function() {
  var __sections__ = {};
  (function() {
    for(var i = 0, s = document.getElementById('sections-script').getAttribute('data-sections').split(','); i < s.length; i++)
      __sections__[s[i]] = true;
    })();
    (function() {
  if (!__sections__["lp-focused-checkout"] && !Shopify.designMode) return;
  try {
    

    /* ── Countdown ───────────────────────────────────────────── */
    (function () {
      const root = document.querySelector('[data-deadline]');
      if (!root) return;
      const deadline = new Date(root.dataset.deadline).getTime();
      const dEl = root.querySelector('[data-d]');
      const hEl = root.querySelector('[data-h]');
      const mEl = root.querySelector('[data-m]');
      const sEl = root.querySelector('[data-s]');
      function pad(n) { return n < 10 ? '0' + n : '' + n; }
      function tick() {
        const ms = Math.max(0, deadline - Date.now());
        const s = Math.floor(ms / 1000);
        dEl.textContent = pad(Math.floor(s / 86400));
        hEl.textContent = pad(Math.floor((s % 86400) / 3600));
        mEl.textContent = pad(Math.floor((s % 3600) / 60));
        sEl.textContent = pad(s % 60);
      }
      tick();
      setInterval(tick, 1000);
    })();

    /* ── Top + bottom sticky bars appear after hero ───────────── */
    (function () {
      const top = document.getElementById('stickybar');
      const bot = document.getElementById('bsticky');
      const hero = document.querySelector('.hero-stack');
      if (!hero) return;
      const obs = new IntersectionObserver(function (entries) {
        entries.forEach(function (e) {
          if (e.isIntersecting) {
            if (top) top.classList.remove('is-on');
            if (bot) bot.classList.remove('is-on');
          } else {
            if (top) top.classList.add('is-on');
            if (bot) bot.classList.add('is-on');
          }
        });
      }, { rootMargin: '-200px 0px 0px 0px' });
      obs.observe(hero);
    })();

    /* ── Hero 1:1 carousel (slides + thumbs + dots) ──────────── */
    (function () {
      const car = document.querySelector('[data-hcar]');
      if (!car) return;
      const track = car.querySelector('[data-hcar-track]');
      const dots = car.querySelectorAll('.hcar__dot');
      const thumbs = document.querySelectorAll('.hthumb');
      let i = 0;
      function go(n) {
        const total = track.children.length;
        i = (n + total) % total;
        track.style.transform = 'translateX(-' + (i * 100) + '%)';
        dots.forEach(function (d, k) { d.classList.toggle('is-on', k === i); });
        thumbs.forEach(function (t, k) { t.classList.toggle('is-on', k === i); });
      }
      dots.forEach(function (d) { d.addEventListener('click', function () { go(parseInt(d.dataset.i, 10)); }); });
      thumbs.forEach(function (t) { t.addEventListener('click', function () { go(parseInt(t.dataset.i, 10)); }); });
      const next = car.querySelector('[data-hcar-next]');
      if (next) next.addEventListener('click', function () { go(i + 1); });
      const prev = car.querySelector('[data-hcar-prev]');
      if (prev) prev.addEventListener('click', function () { go(i - 1); });
      // swipe
      let sx = null;
      car.addEventListener('touchstart', function (e) { sx = e.touches[0].clientX; }, { passive: true });
      car.addEventListener('touchend', function (e) {
        if (sx == null) return;
        const dx = e.changedTouches[0].clientX - sx;
        if (Math.abs(dx) > 40) go(i + (dx < 0 ? 1 : -1));
        sx = null;
      });
    })();

    /* ── Bundle ladder → live price update (CTA + sticky) ────── */
    (function () {
      function updatePrice() {
        const sel = document.querySelector('.ladder .ladder__card.is-on');
        if (!sel) return;
        const now = sel.dataset.price;
        const list = sel.dataset.list;
        const pack = parseInt(sel.dataset.pack, 10);
        var money = function (n) { return (window.WillaMoney ? WillaMoney.fmt(parseFloat(n)) : '$' + n); };
        document.querySelectorAll('[data-now-price]').forEach(function (el) { el.textContent = money(now); });
        document.querySelectorAll('[data-list-price]').forEach(function (el) {
          if (list) { el.textContent = money(list); el.style.display = ''; }
          else { el.style.display = 'none'; }
        });
        document.querySelectorAll('[data-pack-label]').forEach(function (el) {
          if (pack === 1)      el.textContent = 'Claim Your Willa';
          else if (pack === 2) el.textContent = '2-Pack · ' + money(39) + '/pair';
          else if (pack === 4) el.textContent = '4-Pack · ' + money(29) + '/pair';
          else                 el.textContent = pack + '-Pack';
        });
      }
      function updateUnlocks() {
        const sel = document.querySelector('.ladder .ladder__card.is-on');
        const pack = sel ? parseInt(sel.dataset.pack, 10) : 0;
        document.querySelectorAll('.ipdp__free > [data-unlock]').forEach(function (el) {
          const need = parseInt(el.dataset.unlock, 10);
          el.classList.toggle('is-locked', pack < need);
        });
      }
      const cards = document.querySelectorAll('.ladder .ladder__card');
      cards.forEach(function (c) {
        c.addEventListener('click', function () {
          cards.forEach(function (x) { x.classList.remove('is-on'); });
          c.classList.add('is-on');
          updatePrice();
          updateUnlocks();
          if (typeof heroLivePreview !== 'undefined') heroLivePreview.refresh();
        });
      });
      updatePrice();
      updateUnlocks();
    })();

    /* ── Hero benefits tabs ──────────────────────────────────── */
    (function () {
      const tabs = document.querySelectorAll('.hero__tab');
      const panes = document.querySelectorAll('[data-pane]');
      tabs.forEach(function (t) {
        t.addEventListener('click', function () {
          tabs.forEach(function (x) { x.classList.remove('is-on'); });
          t.classList.add('is-on');
          panes.forEach(function (p) {
            p.hidden = p.dataset.pane !== t.dataset.tab;
          });
        });
      });
    })();

    /* ── Bundle ladder mutual-exclusive selection ────────────── */
    (function () {
      document.querySelectorAll('.ladder').forEach(function (ladder) {
        const cards = ladder.querySelectorAll('.ladder__card');
        cards.forEach(function (c) {
          c.addEventListener('click', function () {
            cards.forEach(function (x) { x.classList.remove('is-on'); });
            c.classList.add('is-on');
          });
        });
      });
    })();

    /* ── Subscribe toggle ────────────────────────────────────── */
    (function () {
      const sub = document.getElementById('sub-toggle');
      if (!sub) return;
      sub.addEventListener('click', function () {
        sub.classList.toggle('is-on');
      });
    })();

    /* ── Hold-bundle reservation timer (resets on idle) ──────── */
    (function () {
      const el = document.getElementById('hold-timer');
      if (!el) return;
      let secs = 7 * 60;
      function pad(n) { return n < 10 ? '0' + n : '' + n; }
      function tick() {
        const m = Math.floor(secs / 60);
        const s = secs % 60;
        el.textContent = pad(m) + ':' + pad(s);
        if (secs > 0) secs--;
      }
      tick();
      setInterval(tick, 1000);
    })();


  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["lp-rip-resistant-cro"] && !Shopify.designMode) return;
  try {
    

    /* ── Countdown ───────────────────────────────────────────── */
    (function () {
      /* Store-wide evergreen countdown: every visitor computes the SAME deadline (no storage).
         Time runs in fixed pseudo-random cycles of 10-15 days, seeded per cycle so all
         browsers agree. When a cycle is within 15 min of ending, everyone advances together —
         the timer never gets stuck at 00:00:00. */
      const root = document.querySelector('[data-deadline]');
      if (!root) return;
      const dEl = root.querySelector('[data-d]');
      const hEl = root.querySelector('[data-h]');
      const mEl = root.querySelector('[data-m]');
      const sEl = root.querySelector('[data-s]');
      const DAY = 86400000;
      const RESET_BELOW = 15 * 60 * 1000;        /* 15 minutes */
      const ANCHOR = Date.UTC(2026, 0, 1);       /* fixed epoch, identical for everyone */
      function rand(n) {                          /* deterministic [0,1) from integer seed */
        let t = (n + 0x6D2B79F5) | 0;
        t = Math.imul(t ^ (t >>> 15), t | 1);
        t ^= t + Math.imul(t ^ (t >>> 7), t | 61);
        return ((t ^ (t >>> 14)) >>> 0) / 4294967296;
      }
      function cycleLen(n) { return Math.round((10 + rand(n) * 5) * DAY); }  /* 10-15 days */
      let i = 0, end = ANCHOR;
      function pad(x) { return x < 10 ? '0' + x : '' + x; }
      function tick() {
        const now = Date.now();
        while (end - now < RESET_BELOW) { end += cycleLen(i); i++; }
        const ms = end - now;
        const s = Math.floor(ms / 1000);
        dEl.textContent = pad(Math.floor(s / 86400));
        hEl.textContent = pad(Math.floor((s % 86400) / 3600));
        mEl.textContent = pad(Math.floor((s % 3600) / 60));
        sEl.textContent = pad(s % 60);
      }
      tick();
      setInterval(tick, 1000);
    })();

    /* ── Top + bottom sticky bars appear after hero ───────────── */
    (function () {
      const top = document.getElementById('stickybar');
      const bot = document.getElementById('bsticky');
      const hero = document.querySelector('.hero-stack');
      if (!hero) return;
      const obs = new IntersectionObserver(function (entries) {
        entries.forEach(function (e) {
          if (e.isIntersecting) {
            if (top) top.classList.remove('is-on');
            if (bot) bot.classList.remove('is-on');
          } else {
            if (top) top.classList.add('is-on');
            if (bot) bot.classList.add('is-on');
          }
        });
      }, { rootMargin: '-200px 0px 0px 0px' });
      obs.observe(hero);
    })();

    /* ── Hero 1:1 carousel (slides + thumbs + dots) ──────────── */
    (function () {
      const car = document.querySelector('[data-hcar]');
      if (!car) return;
      const track = car.querySelector('[data-hcar-track]');
      const dots = car.querySelectorAll('.hcar__dot');
      const thumbs = document.querySelectorAll('.hthumb');
      let i = 0;
      function go(n) {
        const total = track.children.length;
        i = (n + total) % total;
        track.style.transform = 'translateX(-' + (i * 100) + '%)';
        dots.forEach(function (d, k) { d.classList.toggle('is-on', k === i); });
        thumbs.forEach(function (t, k) { t.classList.toggle('is-on', k === i); });
      }
      dots.forEach(function (d) { d.addEventListener('click', function () { go(parseInt(d.dataset.i, 10)); }); });
      thumbs.forEach(function (t) { t.addEventListener('click', function () { go(parseInt(t.dataset.i, 10)); }); });
      const next = car.querySelector('[data-hcar-next]');
      if (next) next.addEventListener('click', function () { go(i + 1); });
      const prev = car.querySelector('[data-hcar-prev]');
      if (prev) prev.addEventListener('click', function () { go(i - 1); });
      // swipe
      let sx = null;
      car.addEventListener('touchstart', function (e) { sx = e.touches[0].clientX; }, { passive: true });
      car.addEventListener('touchend', function (e) {
        if (sx == null) return;
        const dx = e.changedTouches[0].clientX - sx;
        if (Math.abs(dx) > 40) go(i + (dx < 0 ? 1 : -1));
        sx = null;
      });
    })();

    /* ── Bundle ladder → live price update (CTA + sticky) ────── */
    (function () {
      function updatePrice() {
        const sel = document.querySelector('.ladder .ladder__card.is-on');
        if (!sel) return;
        const now = sel.dataset.price;
        const list = sel.dataset.list;
        const pack = parseInt(sel.dataset.pack, 10);
        var money = function (n) { return (window.WillaMoney ? WillaMoney.fmt(parseFloat(n)) : '$' + n); };
        document.querySelectorAll('[data-now-price]').forEach(function (el) { el.textContent = money(now); });
        document.querySelectorAll('[data-list-price]').forEach(function (el) {
          if (list) { el.textContent = money(list); el.style.display = ''; }
          else { el.style.display = 'none'; }
        });
        document.querySelectorAll('[data-pack-label]').forEach(function (el) {
          if (pack === 1)      el.textContent = '1 Pair · ' + money(49) + '/pair';
          else if (pack === 2) el.textContent = '2-Pair · ' + money(39) + '/pair';
          else if (pack === 4) el.textContent = '4-Pair · ' + money(29) + '/pair';
          else if (pack === 6) el.textContent = '6-Pair · ' + money(25) + '/pair';
          else                 el.textContent = pack + '-Pair';
        });
      }
      function updateUnlocks() {
        const sel = document.querySelector('.ladder .ladder__card.is-on');
        const pack = sel ? parseInt(sel.dataset.pack, 10) : 0;
        document.querySelectorAll('.ipdp__free > [data-unlock]').forEach(function (el) {
          const need = parseInt(el.dataset.unlock, 10);
          el.classList.toggle('is-locked', pack < need);
        });
      }
      const cards = document.querySelectorAll('.ladder .ladder__card');
      cards.forEach(function (c) {
        c.addEventListener('click', function () {
          cards.forEach(function (x) { x.classList.remove('is-on'); });
          c.classList.add('is-on');
          updatePrice();
          updateUnlocks();
          if (typeof heroLivePreview !== 'undefined') heroLivePreview.refresh();
        });
      });
      updatePrice();
      updateUnlocks();
    })();

    /* ── Hero benefits tabs ──────────────────────────────────── */
    (function () {
      const tabs = document.querySelectorAll('.hero__tab');
      const panes = document.querySelectorAll('[data-pane]');
      tabs.forEach(function (t) {
        t.addEventListener('click', function () {
          tabs.forEach(function (x) { x.classList.remove('is-on'); });
          t.classList.add('is-on');
          panes.forEach(function (p) {
            p.hidden = p.dataset.pane !== t.dataset.tab;
          });
        });
      });
    })();

    /* ── Bundle ladder mutual-exclusive selection ────────────── */
    (function () {
      document.querySelectorAll('.ladder').forEach(function (ladder) {
        const cards = ladder.querySelectorAll('.ladder__card');
        cards.forEach(function (c) {
          c.addEventListener('click', function () {
            cards.forEach(function (x) { x.classList.remove('is-on'); });
            c.classList.add('is-on');
          });
        });
      });
    })();

    /* ── Subscribe toggle ────────────────────────────────────── */
    (function () {
      const sub = document.getElementById('sub-toggle');
      if (!sub) return;
      sub.addEventListener('click', function () {
        sub.classList.toggle('is-on');
      });
    })();

    /* ── Hold-bundle reservation timer (resets on idle) ──────── */
    (function () {
      const el = document.getElementById('hold-timer');
      if (!el) return;
      let secs = 7 * 60;
      function pad(n) { return n < 10 ? '0' + n : '' + n; }
      function tick() {
        const m = Math.floor(secs / 60);
        const s = secs % 60;
        el.textContent = pad(m) + ':' + pad(s);
        if (secs > 0) secs--;
      }
      tick();
      setInterval(tick, 1000);
    })();


  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["lp-rip-resistant"] && !Shopify.designMode) return;
  try {
    

    /* ── Countdown ───────────────────────────────────────────── */
    (function () {
      /* Store-wide evergreen countdown: every visitor computes the SAME deadline (no storage).
         Time runs in fixed pseudo-random cycles of 10-15 days, seeded per cycle so all
         browsers agree. When a cycle is within 15 min of ending, everyone advances together —
         the timer never gets stuck at 00:00:00. */
      const root = document.querySelector('[data-deadline]');
      if (!root) return;
      const dEl = root.querySelector('[data-d]');
      const hEl = root.querySelector('[data-h]');
      const mEl = root.querySelector('[data-m]');
      const sEl = root.querySelector('[data-s]');
      const DAY = 86400000;
      const RESET_BELOW = 15 * 60 * 1000;        /* 15 minutes */
      const ANCHOR = Date.UTC(2026, 0, 1);       /* fixed epoch, identical for everyone */
      function rand(n) {                          /* deterministic [0,1) from integer seed */
        let t = (n + 0x6D2B79F5) | 0;
        t = Math.imul(t ^ (t >>> 15), t | 1);
        t ^= t + Math.imul(t ^ (t >>> 7), t | 61);
        return ((t ^ (t >>> 14)) >>> 0) / 4294967296;
      }
      function cycleLen(n) { return Math.round((10 + rand(n) * 5) * DAY); }  /* 10-15 days */
      let i = 0, end = ANCHOR;
      function pad(x) { return x < 10 ? '0' + x : '' + x; }
      function tick() {
        const now = Date.now();
        while (end - now < RESET_BELOW) { end += cycleLen(i); i++; }
        const ms = end - now;
        const s = Math.floor(ms / 1000);
        dEl.textContent = pad(Math.floor(s / 86400));
        hEl.textContent = pad(Math.floor((s % 86400) / 3600));
        mEl.textContent = pad(Math.floor((s % 3600) / 60));
        sEl.textContent = pad(s % 60);
      }
      tick();
      setInterval(tick, 1000);
    })();

    /* ── Top + bottom sticky bars appear after hero ───────────── */
    (function () {
      const top = document.getElementById('stickybar');
      const bot = document.getElementById('bsticky');
      const hero = document.querySelector('.hero-stack');
      if (!hero) return;
      const obs = new IntersectionObserver(function (entries) {
        entries.forEach(function (e) {
          if (e.isIntersecting) {
            if (top) top.classList.remove('is-on');
            if (bot) bot.classList.remove('is-on');
          } else {
            if (top) top.classList.add('is-on');
            if (bot) bot.classList.add('is-on');
          }
        });
      }, { rootMargin: '-200px 0px 0px 0px' });
      obs.observe(hero);
    })();

    /* ── Hero 1:1 carousel (slides + thumbs + dots) ──────────── */
    (function () {
      const car = document.querySelector('[data-hcar]');
      if (!car) return;
      const track = car.querySelector('[data-hcar-track]');
      const dots = car.querySelectorAll('.hcar__dot');
      const thumbs = document.querySelectorAll('.hthumb');
      let i = 0;
      function go(n) {
        const total = track.children.length;
        i = (n + total) % total;
        track.style.transform = 'translateX(-' + (i * 100) + '%)';
        dots.forEach(function (d, k) { d.classList.toggle('is-on', k === i); });
        thumbs.forEach(function (t, k) { t.classList.toggle('is-on', k === i); });
      }
      dots.forEach(function (d) { d.addEventListener('click', function () { go(parseInt(d.dataset.i, 10)); }); });
      thumbs.forEach(function (t) { t.addEventListener('click', function () { go(parseInt(t.dataset.i, 10)); }); });
      const next = car.querySelector('[data-hcar-next]');
      if (next) next.addEventListener('click', function () { go(i + 1); });
      const prev = car.querySelector('[data-hcar-prev]');
      if (prev) prev.addEventListener('click', function () { go(i - 1); });
      // swipe
      let sx = null;
      car.addEventListener('touchstart', function (e) { sx = e.touches[0].clientX; }, { passive: true });
      car.addEventListener('touchend', function (e) {
        if (sx == null) return;
        const dx = e.changedTouches[0].clientX - sx;
        if (Math.abs(dx) > 40) go(i + (dx < 0 ? 1 : -1));
        sx = null;
      });
    })();

    /* ── Bundle ladder → live price update (CTA + sticky) ────── */
    (function () {
      function updatePrice() {
        const sel = document.querySelector('.ladder .ladder__card.is-on');
        if (!sel) return;
        const now = sel.dataset.price;
        const list = sel.dataset.list;
        const pack = parseInt(sel.dataset.pack, 10);
        var money = function (n) { return (window.WillaMoney ? WillaMoney.fmt(parseFloat(n)) : '$' + n); };
        document.querySelectorAll('[data-now-price]').forEach(function (el) { el.textContent = money(now); });
        document.querySelectorAll('[data-list-price]').forEach(function (el) {
          if (list) { el.textContent = money(list); el.style.display = ''; }
          else { el.style.display = 'none'; }
        });
        document.querySelectorAll('[data-pack-label]').forEach(function (el) {
          if (pack === 1)      el.textContent = 'Claim Your Willa';
          else if (pack === 2) el.textContent = '2-Pack · ' + money(39) + '/pair';
          else if (pack === 4) el.textContent = '4-Pack · ' + money(29) + '/pair';
          else                 el.textContent = pack + '-Pack';
        });
      }
      function updateUnlocks() {
        const sel = document.querySelector('.ladder .ladder__card.is-on');
        const pack = sel ? parseInt(sel.dataset.pack, 10) : 0;
        document.querySelectorAll('.ipdp__free > [data-unlock]').forEach(function (el) {
          const need = parseInt(el.dataset.unlock, 10);
          el.classList.toggle('is-locked', pack < need);
        });
      }
      const cards = document.querySelectorAll('.ladder .ladder__card');
      cards.forEach(function (c) {
        c.addEventListener('click', function () {
          cards.forEach(function (x) { x.classList.remove('is-on'); });
          c.classList.add('is-on');
          updatePrice();
          updateUnlocks();
          if (typeof heroLivePreview !== 'undefined') heroLivePreview.refresh();
        });
      });
      updatePrice();
      updateUnlocks();
    })();

    /* ── Hero benefits tabs ──────────────────────────────────── */
    (function () {
      const tabs = document.querySelectorAll('.hero__tab');
      const panes = document.querySelectorAll('[data-pane]');
      tabs.forEach(function (t) {
        t.addEventListener('click', function () {
          tabs.forEach(function (x) { x.classList.remove('is-on'); });
          t.classList.add('is-on');
          panes.forEach(function (p) {
            p.hidden = p.dataset.pane !== t.dataset.tab;
          });
        });
      });
    })();

    /* ── Bundle ladder mutual-exclusive selection ────────────── */
    (function () {
      document.querySelectorAll('.ladder').forEach(function (ladder) {
        const cards = ladder.querySelectorAll('.ladder__card');
        cards.forEach(function (c) {
          c.addEventListener('click', function () {
            cards.forEach(function (x) { x.classList.remove('is-on'); });
            c.classList.add('is-on');
          });
        });
      });
    })();

    /* ── Subscribe toggle ────────────────────────────────────── */
    (function () {
      const sub = document.getElementById('sub-toggle');
      if (!sub) return;
      sub.addEventListener('click', function () {
        sub.classList.toggle('is-on');
      });
    })();

    /* ── Hold-bundle reservation timer (resets on idle) ──────── */
    (function () {
      const el = document.getElementById('hold-timer');
      if (!el) return;
      let secs = 7 * 60;
      function pad(n) { return n < 10 ? '0' + n : '' + n; }
      function tick() {
        const m = Math.floor(secs / 60);
        const s = secs % 60;
        el.textContent = pad(m) + ':' + pad(s);
        if (secs > 0) secs--;
      }
      tick();
      setInterval(tick, 1000);
    })();


  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["lp-rip-resistant2"] && !Shopify.designMode) return;
  try {
    

    /* ── Countdown ───────────────────────────────────────────── */
    (function () {
      /* Store-wide countdown: every visitor computes the SAME deadline (no storage).
         Time runs in fixed pseudo-random cycles of 10-15 days, seeded per cycle so all
         browsers agree. When a cycle is within 15 min of ending, everyone advances together. */
      const root = document.querySelector('[data-deadline]');
      if (!root) return;
      const dEl = root.querySelector('[data-d]');
      const hEl = root.querySelector('[data-h]');
      const mEl = root.querySelector('[data-m]');
      const sEl = root.querySelector('[data-s]');
      const DAY = 86400000;
      const RESET_BELOW = 15 * 60 * 1000;        /* 15 minutes */
      const ANCHOR = Date.UTC(2026, 0, 1);       /* fixed epoch, identical for everyone */
      function rand(n) {                          /* deterministic [0,1) from integer seed */
        let t = (n + 0x6D2B79F5) | 0;
        t = Math.imul(t ^ (t >>> 15), t | 1);
        t ^= t + Math.imul(t ^ (t >>> 7), t | 61);
        return ((t ^ (t >>> 14)) >>> 0) / 4294967296;
      }
      function cycleLen(n) { return Math.round((10 + rand(n) * 5) * DAY); }  /* 10-15 days */
      let i = 0, end = ANCHOR;
      function pad(x) { return x < 10 ? '0' + x : '' + x; }
      function tick() {
        const now = Date.now();
        while (end - now < RESET_BELOW) { end += cycleLen(i); i++; }
        const ms = end - now;
        const s = Math.floor(ms / 1000);
        dEl.textContent = pad(Math.floor(s / 86400));
        hEl.textContent = pad(Math.floor((s % 86400) / 3600));
        mEl.textContent = pad(Math.floor((s % 3600) / 60));
        sEl.textContent = pad(s % 60);
      }
      tick();
      setInterval(tick, 1000);
    })();

    /* ── Top + bottom sticky bars appear after hero ───────────── */
    (function () {
      const top = document.getElementById('stickybar');
      const bot = document.getElementById('bsticky');
      const hero = document.querySelector('.hero-stack');
      if (!hero) return;
      const obs = new IntersectionObserver(function (entries) {
        entries.forEach(function (e) {
          if (e.isIntersecting) {
            if (top) top.classList.remove('is-on');
            if (bot) bot.classList.remove('is-on');
          } else {
            if (top) top.classList.add('is-on');
            if (bot) bot.classList.add('is-on');
          }
        });
      }, { rootMargin: '-200px 0px 0px 0px' });
      obs.observe(hero);
    })();

    /* ── Hero 1:1 carousel (slides + thumbs + dots) ──────────── */
    (function () {
      const car = document.querySelector('[data-hcar]');
      if (!car) return;
      const track = car.querySelector('[data-hcar-track]');
      const dots = car.querySelectorAll('.hcar__dot');
      const thumbs = document.querySelectorAll('.hthumb');
      let i = 0;
      function go(n) {
        const total = track.children.length;
        i = (n + total) % total;
        track.style.transform = 'translateX(-' + (i * 100) + '%)';
        dots.forEach(function (d, k) { d.classList.toggle('is-on', k === i); });
        thumbs.forEach(function (t, k) { t.classList.toggle('is-on', k === i); });
      }
      dots.forEach(function (d) { d.addEventListener('click', function () { go(parseInt(d.dataset.i, 10)); }); });
      thumbs.forEach(function (t) { t.addEventListener('click', function () { go(parseInt(t.dataset.i, 10)); }); });
      const next = car.querySelector('[data-hcar-next]');
      if (next) next.addEventListener('click', function () { go(i + 1); });
      const prev = car.querySelector('[data-hcar-prev]');
      if (prev) prev.addEventListener('click', function () { go(i - 1); });
      // swipe
      let sx = null;
      car.addEventListener('touchstart', function (e) { sx = e.touches[0].clientX; }, { passive: true });
      car.addEventListener('touchend', function (e) {
        if (sx == null) return;
        const dx = e.changedTouches[0].clientX - sx;
        if (Math.abs(dx) > 40) go(i + (dx < 0 ? 1 : -1));
        sx = null;
      });
    })();

    /* ── Bundle ladder → live price update (CTA + sticky) ────── */
    (function () {
      function updatePrice() {
        const sel = document.querySelector('.ladder .ladder__card.is-on');
        if (!sel) return;
        const now = sel.dataset.price;
        const list = sel.dataset.list;
        const pack = parseInt(sel.dataset.pack, 10);
        var money = function (n) { return (window.WillaMoney ? WillaMoney.fmt(parseFloat(n)) : '$' + n); };
        document.querySelectorAll('[data-now-price]').forEach(function (el) { el.textContent = money(now); });
        document.querySelectorAll('[data-list-price]').forEach(function (el) {
          if (list) { el.textContent = money(list); el.style.display = ''; }
          else { el.style.display = 'none'; }
        });
        document.querySelectorAll('[data-pack-label]').forEach(function (el) {
          if (pack === 1)      el.textContent = 'Claim Your Willa';
          else if (pack === 2) el.textContent = '2-Pack · ' + money(49) + '/pair';
          else if (pack === 4) el.textContent = '4-Pack · ' + money(39) + '/pair';
          else                 el.textContent = pack + '-Pack';
        });
      }
      function updateUnlocks() {
        const sel = document.querySelector('.ladder .ladder__card.is-on');
        const pack = sel ? parseInt(sel.dataset.pack, 10) : 0;
        document.querySelectorAll('.ipdp__free > [data-unlock]').forEach(function (el) {
          const need = parseInt(el.dataset.unlock, 10);
          el.classList.toggle('is-locked', pack < need);
        });
      }
      const cards = document.querySelectorAll('.ladder .ladder__card');
      cards.forEach(function (c) {
        c.addEventListener('click', function () {
          cards.forEach(function (x) { x.classList.remove('is-on'); });
          c.classList.add('is-on');
          updatePrice();
          updateUnlocks();
          if (typeof heroLivePreview !== 'undefined') heroLivePreview.refresh();
        });
      });
      updatePrice();
      updateUnlocks();
    })();

    /* ── Hero benefits tabs ──────────────────────────────────── */
    (function () {
      const tabs = document.querySelectorAll('.hero__tab');
      const panes = document.querySelectorAll('[data-pane]');
      tabs.forEach(function (t) {
        t.addEventListener('click', function () {
          tabs.forEach(function (x) { x.classList.remove('is-on'); });
          t.classList.add('is-on');
          panes.forEach(function (p) {
            p.hidden = p.dataset.pane !== t.dataset.tab;
          });
        });
      });
    })();

    /* ── Bundle ladder mutual-exclusive selection ────────────── */
    (function () {
      document.querySelectorAll('.ladder').forEach(function (ladder) {
        const cards = ladder.querySelectorAll('.ladder__card');
        cards.forEach(function (c) {
          c.addEventListener('click', function () {
            cards.forEach(function (x) { x.classList.remove('is-on'); });
            c.classList.add('is-on');
          });
        });
      });
    })();

    /* ── Subscribe toggle ────────────────────────────────────── */
    (function () {
      const sub = document.getElementById('sub-toggle');
      if (!sub) return;
      sub.addEventListener('click', function () {
        sub.classList.toggle('is-on');
      });
    })();

    /* ── Hold-bundle reservation timer (resets on idle) ──────── */
    (function () {
      const el = document.getElementById('hold-timer');
      if (!el) return;
      let secs = 7 * 60;
      function pad(n) { return n < 10 ? '0' + n : '' + n; }
      function tick() {
        const m = Math.floor(secs / 60);
        const s = secs % 60;
        el.textContent = pad(m) + ':' + pad(s);
        if (secs > 0) secs--;
      }
      tick();
      setInterval(tick, 1000);
    })();


  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["lp-rrpdp"] && !Shopify.designMode) return;
  try {
    

    /* ── Countdown ───────────────────────────────────────────── */
    (function () {
      /* Store-wide evergreen countdown: every visitor computes the SAME deadline (no storage).
         Time runs in fixed pseudo-random cycles of 10-15 days, seeded per cycle so all
         browsers agree. When a cycle is within 15 min of ending, everyone advances together —
         the timer never gets stuck at 00:00:00. */
      const root = document.querySelector('[data-deadline]');
      if (!root) return;
      const dEl = root.querySelector('[data-d]');
      const hEl = root.querySelector('[data-h]');
      const mEl = root.querySelector('[data-m]');
      const sEl = root.querySelector('[data-s]');
      const DAY = 86400000;
      const RESET_BELOW = 15 * 60 * 1000;        /* 15 minutes */
      const ANCHOR = Date.UTC(2026, 0, 1);       /* fixed epoch, identical for everyone */
      function rand(n) {                          /* deterministic [0,1) from integer seed */
        let t = (n + 0x6D2B79F5) | 0;
        t = Math.imul(t ^ (t >>> 15), t | 1);
        t ^= t + Math.imul(t ^ (t >>> 7), t | 61);
        return ((t ^ (t >>> 14)) >>> 0) / 4294967296;
      }
      function cycleLen(n) { return Math.round((10 + rand(n) * 5) * DAY); }  /* 10-15 days */
      let i = 0, end = ANCHOR;
      function pad(x) { return x < 10 ? '0' + x : '' + x; }
      function tick() {
        const now = Date.now();
        while (end - now < RESET_BELOW) { end += cycleLen(i); i++; }
        const ms = end - now;
        const s = Math.floor(ms / 1000);
        dEl.textContent = pad(Math.floor(s / 86400));
        hEl.textContent = pad(Math.floor((s % 86400) / 3600));
        mEl.textContent = pad(Math.floor((s % 3600) / 60));
        sEl.textContent = pad(s % 60);
      }
      tick();
      setInterval(tick, 1000);
    })();

    /* ── Top + bottom sticky bars appear after hero ───────────── */
    (function () {
      const top = document.getElementById('stickybar');
      const bot = document.getElementById('bsticky');
      const hero = document.querySelector('.hero-stack');
      if (!hero) return;
      const obs = new IntersectionObserver(function (entries) {
        entries.forEach(function (e) {
          if (e.isIntersecting) {
            if (top) top.classList.remove('is-on');
            if (bot) bot.classList.remove('is-on');
          } else {
            if (top) top.classList.add('is-on');
            if (bot) bot.classList.add('is-on');
          }
        });
      }, { rootMargin: '-200px 0px 0px 0px' });
      obs.observe(hero);
    })();

    /* ── Hero 1:1 carousel (slides + thumbs + dots) ──────────── */
    (function () {
      const car = document.querySelector('[data-hcar]');
      if (!car) return;
      const track = car.querySelector('[data-hcar-track]');
      const dots = car.querySelectorAll('.hcar__dot');
      const thumbs = document.querySelectorAll('.hthumb');
      let i = 0;
      function go(n) {
        const total = track.children.length;
        i = (n + total) % total;
        track.style.transform = 'translateX(-' + (i * 100) + '%)';
        dots.forEach(function (d, k) { d.classList.toggle('is-on', k === i); });
        thumbs.forEach(function (t, k) { t.classList.toggle('is-on', k === i); });
      }
      dots.forEach(function (d) { d.addEventListener('click', function () { go(parseInt(d.dataset.i, 10)); }); });
      thumbs.forEach(function (t) { t.addEventListener('click', function () { go(parseInt(t.dataset.i, 10)); }); });
      const next = car.querySelector('[data-hcar-next]');
      if (next) next.addEventListener('click', function () { go(i + 1); });
      const prev = car.querySelector('[data-hcar-prev]');
      if (prev) prev.addEventListener('click', function () { go(i - 1); });
      // swipe
      let sx = null;
      car.addEventListener('touchstart', function (e) { sx = e.touches[0].clientX; }, { passive: true });
      car.addEventListener('touchend', function (e) {
        if (sx == null) return;
        const dx = e.changedTouches[0].clientX - sx;
        if (Math.abs(dx) > 40) go(i + (dx < 0 ? 1 : -1));
        sx = null;
      });
    })();

    /* ── Bundle ladder → live price update (CTA + sticky) ────── */
    (function () {
      function updatePrice() {
        const sel = document.querySelector('.ladder .ladder__card.is-on');
        if (!sel) return;
        const now = sel.dataset.price;
        const list = sel.dataset.list;
        const pack = parseInt(sel.dataset.pack, 10);
        var money = function (n) { return (window.WillaMoney ? WillaMoney.fmt(parseFloat(n)) : '$' + n); };
        document.querySelectorAll('[data-now-price]').forEach(function (el) { el.textContent = money(now); });
        document.querySelectorAll('[data-list-price]').forEach(function (el) {
          if (list) { el.textContent = money(list); el.style.display = ''; }
          else { el.style.display = 'none'; }
        });
        document.querySelectorAll('[data-pack-label]').forEach(function (el) {
          if (pack === 1)      el.textContent = 'Claim Your Willa';
          else if (pack === 2) el.textContent = '2-Pack · ' + money(39) + '/pair';
          else if (pack === 4) el.textContent = '4-Pack · ' + money(29) + '/pair';
          else                 el.textContent = pack + '-Pack';
        });
      }
      function updateUnlocks() {
        const sel = document.querySelector('.ladder .ladder__card.is-on');
        const pack = sel ? parseInt(sel.dataset.pack, 10) : 0;
        document.querySelectorAll('.ipdp__free > [data-unlock]').forEach(function (el) {
          const need = parseInt(el.dataset.unlock, 10);
          el.classList.toggle('is-locked', pack < need);
        });
      }
      const cards = document.querySelectorAll('.ladder .ladder__card');
      cards.forEach(function (c) {
        c.addEventListener('click', function () {
          cards.forEach(function (x) { x.classList.remove('is-on'); });
          c.classList.add('is-on');
          updatePrice();
          updateUnlocks();
          if (typeof heroLivePreview !== 'undefined') heroLivePreview.refresh();
        });
      });
      updatePrice();
      updateUnlocks();
    })();

    /* ── Hero benefits tabs ──────────────────────────────────── */
    (function () {
      const tabs = document.querySelectorAll('.hero__tab');
      const panes = document.querySelectorAll('[data-pane]');
      tabs.forEach(function (t) {
        t.addEventListener('click', function () {
          tabs.forEach(function (x) { x.classList.remove('is-on'); });
          t.classList.add('is-on');
          panes.forEach(function (p) {
            p.hidden = p.dataset.pane !== t.dataset.tab;
          });
        });
      });
    })();

    /* ── Bundle ladder mutual-exclusive selection ────────────── */
    (function () {
      document.querySelectorAll('.ladder').forEach(function (ladder) {
        const cards = ladder.querySelectorAll('.ladder__card');
        cards.forEach(function (c) {
          c.addEventListener('click', function () {
            cards.forEach(function (x) { x.classList.remove('is-on'); });
            c.classList.add('is-on');
          });
        });
      });
    })();

    /* ── Subscribe toggle ────────────────────────────────────── */
    (function () {
      const sub = document.getElementById('sub-toggle');
      if (!sub) return;
      sub.addEventListener('click', function () {
        sub.classList.toggle('is-on');
      });
    })();

    /* ── Hold-bundle reservation timer (resets on idle) ──────── */
    (function () {
      const el = document.getElementById('hold-timer');
      if (!el) return;
      let secs = 7 * 60;
      function pad(n) { return n < 10 ? '0' + n : '' + n; }
      function tick() {
        const m = Math.floor(secs / 60);
        const s = secs % 60;
        el.textContent = pad(m) + ':' + pad(s);
        if (secs > 0) secs--;
      }
      tick();
      setInterval(tick, 1000);
    })();


  } catch(e) { console.error(e); }
})();
})();
